import React from 'react';
import PropTypes from 'prop-types';

// MUI stuff
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';

// Icon
import LocationOn from '@mui/icons-material/LocationOn';
import LinkIcon from '@mui/icons-material/Link';
import CalendarToday from '@mui/icons-material/CalendarToday';

import NoImg from '../images/no-img.png';
import theme from '../utils/theme';

const styles = {
    ...theme,
    handle: {
        height: 25,
        backgroundColor: theme.palette.primary.main,
        width: 70,
        margin: '0 auto 7px auto'
    },
    fullLine: {
        height: 20,
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        margin: '0 auto 7px auto'
    }
};

const ProfileSkeleton = props => {

    const { classes } = props;

    return (
        <Paper className={classes.paper}>
            <div className={classes.profile}>
                <div className="image-wrapper">
                    <img src={NoImg} alt="profile" className="profile-image" />
                </div>
                <hr />
                <div className="profile-details">
                    <div className={classes.handle} />
                    <hr />
                    <div className={classes.fullLine} />
                    <div className={classes.fullLine} />
                    <hr />
                    <LocationOn color="primary" /><span>Location</span>
                    <hr />
                    <LinkIcon color="primary" />https://website.com
                    <hr />
                    <CalendarToday color="primary" />Joined Date
                </div>
            </div>
        </Paper>
    )
}

ProfileSkeleton.propTypes = { classes: PropTypes.object.isRequired };

export default withStyles(styles)(ProfileSkeleton);
